import {AfterViewInit, Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {SharedPreference} from '../../shared-preference/shared-perference';
import {User} from '../../model/user';
import {AuthenticationService} from "../../services/authentication.service";
import {environment} from "../../../environments/environment";
import {Role} from "../../model/role";
import {Router} from '@angular/router';
import {LanguageServiceService, StoreIdService, CurrencyService} from '../../services';
import {DomainNameParserService} from '../../services/domain-name-parser.service';
import {DOCUMENT} from '@angular/platform-browser';
import {Location} from '@angular/common';
import {StringUtils} from '../../utils/string-utils';
import {StoreUtils} from '../../utils/store-utils';
import {StoreSettingUtil} from '../../utils/store-setting-util';
import {FirebaseService} from '../../services/firebase.service';
import {LoggUtilInfo} from '../../utils/loggUtil';
import {StringFieldUtil} from '../../utils/string-field-util';
import {ToasterService} from '../../services/toaster.service';
import {SystemConfigUtils} from '../../utils/system-config-utils';
import {ApiService} from '../../services/http-service/api.service';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements AfterViewInit, OnInit {
  showHide: boolean;
  routerLink: string;
  flagSelected: string;
  ukFlag: string = "assets/home-image/uk-flag.png";
  cambodiaFlag: string = "assets/home-image/cambodia-flag.png";
  isLoginEnable: boolean;
  screenSize: number = StringUtils.screenSize;
  itemList: any = [];
  selectedItems = [];
  temStoreId: string;
  listStoreKey: string[] = [];
  listStoreIds: Map<string, string> = new Map();
  isWhiteLabelApp: boolean;
  selectedCurrency: string;
  currencies: string[] = [];

  dropdownSettings = {
    singleSelection: true,
    text: "Select Store Id",
    enableSearchFilter: true,
    noDataLabel: 'Search item',
    maxHeight: 200,
    disabled: false
  };
  storeIdFromHeader$: any = null;

  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

  constructor(
    private _location: Location,
    private _authenticationService: AuthenticationService,
    public languageService: LanguageServiceService,
    private _firebaseService: FirebaseService,
    private storeIdService: StoreIdService,
    private apiService: ApiService,
    private currencyService: CurrencyService,
    public router: Router,
    public toaster: ToasterService,
    private domainParserService: DomainNameParserService,
    @Inject(DOCUMENT) private document: Document,
    ){}

  async ngOnInit() {
    this.showHide = true;
    this.onChangeLanguage('en');
    this.flagSelected = "assets/home-image/uk-flag.png";
    this.temStoreId = StoreUtils.getSelectStoreId();
    this.getStoresList();
    if (this.isAdmin()) {
      await this.getPlatforms();
    }

    // check domain
    const domainName = this.domainParserService.getDomainName(this.document.location.hostname);
    this.isLoginEnable = (domainName !== "khmumtech.com" && domainName !== "versitasoftware.com");

    const storeId = SharedPreference.getStoreId();
    if (storeId) {
      StoreSettingUtil.onReadStoreSetting(this._firebaseService, storeId, (setting) => {
        this.currencies = this.currencyService.getCurrenciesDisplay();
        this.selectedCurrency = CurrencyService.getDisplayCurrency();
      });
    }

    this.currencies = this.currencyService.getCurrenciesDisplay();
    this.selectedCurrency = CurrencyService.getDisplayCurrency();
  }

  onCurrencyChange(currency: string) {
    this.selectedCurrency = currency;
    this.currencyService.onChangeCurrency(currency);
  }

  async getPlatforms() {
    try {
      const promise: any = await this.apiService.requestPlatforms(null, SharedPreference.getStoreId()).toPromise();
      let platformWhiteLabel = [];
      platformWhiteLabel.push(promise['result']);
      this.isWhiteLabelApp = platformWhiteLabel.length > 0;
    } catch (e) {
      LoggUtilInfo.loggingError("component breadcrumb notification get platform",e);
      return [];
    }
  }

  toggleSideBar() {
    this.toggleSideBarForMe.emit();
    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);
  }

  getScreenSize() : number{
    return StringUtils.screenSize;
  }

  getStoresList(){
    this._firebaseService.onGetDataDocumentStoreList(FirebaseService.storeList).then((value => {
      LoggUtilInfo.loggingEnd(StringUtils.readDocument + FirebaseService.storeList + StringUtils.componentAdminStore);

      let mapStoreIdFromServer: Map<any, any> = StringUtils.objToStrMap(value.data());
      let mapList:  any = [];
      mapStoreIdFromServer.forEach((v, k) => {
        mapList.push({key: k, value: v[StringFieldUtil.storeName]});}
      );
      mapList.push({key: StringUtils.versitaSettingKey, value: StringUtils.versitaSettingValue});

      let data = mapList.sort((a, b) =>
        a.value &&
        b.value &&
        a.value.toLowerCase().localeCompare(b.value.toLowerCase())
      );

      data.forEach((v) =>{
        this.listStoreKey.push(v.key);
        this.listStoreIds.set(v.key, v.value);
        const itemObject = {"id": v.key, 'itemName': v.key + " : " + v.value};
        this.itemList.push(itemObject);
      });

      this.storeIdFromHeader$ = this.storeIdService.onGetStoreId();

      StoreUtils.storeIdMap = this.listStoreIds;

    })).catch((error) => {
      LoggUtilInfo.loggingError(StringUtils.readDocument + FirebaseService.storeList + error.toString() + StringUtils.componentAdminStore);
    });
  }

  getUser() : User{
    return SharedPreference.getUser();
  }

  getPhoneOrEmail() : string{
    try {
      const isPhone = this.getUser().loginVia.toLocaleLowerCase() === 'phone';
      if(isPhone)
        return this.getPhoneNumber(this.getUser());

      return this.getUser().email;
    }catch (e) {
      return this.getUser().email;
    }
  }

  getPhoneNumber(user: User):string{
    try {
      return user.phoneNumber['code'] +" "+ user.phoneNumber['phone'];
    }catch (e) {
      return '';
    }
  }

  async onChangeStoreIdAndName(storeId: string, storeName: string) {
    if(storeId && storeName && this.temStoreId !== storeId){
      const itemObject = {'id': storeId, 'itemName': storeName.includes(":") ? storeName : storeId + " : " + storeName};
      this.selectedItems = [itemObject];
      this.temStoreId = storeId;
    }
  }

  onSelectStoreId(storeId: string, storeName: string): void {
    this.toaster.clear();
    // send message to subscribers via observable subject
    console.log("send message from header..");
    // StoreUtils.setSelectStoreId(storeId);
    this.storeIdService.onStoreIdChange(storeName, storeId);

    if (storeId) {
      const checkAndAssignStore = () => {
        if (StoreUtils.versitaStore && StoreUtils.versitaStore.get(storeId)) {
          StoreUtils.store = StoreUtils.versitaStore.get(storeId);
          this.currencyService.refreshCurrencyFromStore();
          if (SystemConfigUtils.getIsSingleStoreBCSetting() === false) {
            if (!StoreUtils.store.businessSetting.isGoLive) {
              StringUtils.isGoLiveFalse(this.toaster);
            }
          }
          return true;
        }
        return false;
      };

      if (!checkAndAssignStore()) {
        this.onToastShow(storeId);
        const interval = setInterval(() => {
          if (checkAndAssignStore()) {
            clearInterval(interval);
          }
        }, 500);

        // Safety timeout: stop polling after 5 seconds
        setTimeout(() => clearInterval(interval), 5000);
      }
    }
  }

  private onToastShow(storeId: string) {
    if(SystemConfigUtils.getIsSingleStoreBCSetting() === false){
      let self = this;
      StoreUtils.onGetStoreForSetting(this._firebaseService, storeId, function (v) {
        if (!v.businessSetting.isGoLive) {
          StringUtils.isGoLiveFalse(self.toaster);
        }
      });
    }
  }

  OnItemDeSelect(event: any) {
    this.selectedItems = [];
  }

  isVersitaAdmin(){
    if (!SharedPreference.getUser()) {
      return false;
    }
    return Role.hasVersitaAdmin(SharedPreference.getUser());
  }

  isVersitaCustomerService() {
    return Role.hasVersitaCustomerService(SharedPreference.getUser());
  }

  isVersitaSupervisor() {
    return Role.hasVersitaSupervisor(SharedPreference.getUser());
  }

  async onSearch(event) {
    const keyword = event.target.value;
    if (keyword) {
      let search = [];
      this.listStoreIds.forEach((value, key) => {
        if (value.toLocaleLowerCase().includes(keyword.toLocaleLowerCase()) || key.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())) {
          const itemObject = {"id": key, 'itemName': key + " : " + value};
          search.push(itemObject);
        }
      });

      this.itemList = [];
      this.itemList = search;
    } else {
      this.itemList = [];
      this.listStoreIds.forEach((value, key) => {
        const itemObject = {'id': key, 'itemName': key + " : " + value};
        this.itemList.push(itemObject);
      });
    }
  }

  getStoreName(): string {
    if (Role.hasVersitaUser(SharedPreference.getUser())) {
      return SharedPreference.getUserFullName();
    } else {
      return SharedPreference.getStoreName(SharedPreference.getStoreId());
    }

  }

  getCurrencySymbol(currency: string): string {
    if (currency === 'USD') return '$';
    if (currency === 'KHR') return '៛';
    return '';
  }

  logout(): void{
    this._authenticationService.onLogout();
  }

  getIsShowingMenu() :boolean {
    return SharedPreference.isShowingMenu;
  }

  isEnableHomePage(): boolean {
    return environment.isEnableHomePage && !window.location.href.includes('login');
  }

  isLogin(): boolean {
    return SharedPreference.getLogin();
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just valuePrice reminder that you have event',
      time: '9:10 AM'
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung valuePrice song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am valuePrice singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  changeShowStatus() {
    this.showHide = !this.showHide;
  }

  ngAfterViewInit() {
    $(function() {
      $('.preloader').fadeOut();
    });

    const set = function() {
      const width =
        window.innerWidth > 0 ? window.innerWidth : this.screen.width;
      const topOffset = 70;
      if (width < 1170) {
        $('body').addClass('mini-sidebar');
        $('.navbar-brand span').hide();
        $('.sidebartoggler i').addClass('ti-menu');
      } else {
        $('body').removeClass('mini-sidebar');
        $('.navbar-brand span').show();
        $('.sidebartoggler i').removeClass('ti-menu');
      }

      const height =
        (window.innerHeight > 0 ? window.innerHeight : this.screen.height) - 1;

      if (height > topOffset) {
        $('.page-wrapper').css('min-height', height + 'px');
      }
    };
    $(window).ready(set);
    $(window).on('resize', set);

    $(document).on('click', '.mega-dropdown', function(e) {
      e.stopPropagation();
    });

    $('.search-box valuePrice, .search-box .app-search .srh-btn').on(
      'click',
      function() {
        $('.app-search').toggle(200);
      }
    );

    (<any>$('[data-toggle="tooltip"]')).tooltip();

    (<any>$('.right-sidebar')).slimScroll({
      height: '100%',
      position: 'right',
      size: '5px',
      color: '#dcdcdc'
    });

    (<any>$('.message-center')).slimScroll({
      position: 'right',
      size: '5px',
      color: '#dcdcdc'
    });

    $('body').trigger('resize');
  }

  isOnHomePage() {
    return this.router.url === "/home-page";
  }

  isUserLogin() {
    return SharedPreference.getLogin();
  }

  onChangeLanguage(language: string) {
    if (language === 'kh') {
      this.flagSelected = "assets/home-image/cambodia-flag.png"
    } else {
      this.flagSelected = "assets/home-image/uk-flag.png";
    }
    this.languageService.onChangeLanguage(language);
  }

  isAdmin(){
    if (!SharedPreference.getUser()) {
      return false;
    }
    return Role.hasAdminRole(SharedPreference.getUser());
  }

  isOnJoinAsPartner() {
    return this.router.url.includes("/join-as-partner");
  }

  isOnPartnerRegister() {
    return this.router.url.includes("/partner-register")
  }

  back(): void {
    if (this.isOnJoinAsPartner() || this.isOnPartnerRegister()) {
      this._location.back();
    }

  }
}
